'use strict';

var _ = require('lodash');
var SeasonColorService = function SeasonColorService() {
  var seasonsMap = {
    'SUPER PEAK': '#FFD130',
    //#376092
    'SUPERPEAK': '#FFD130',
    //#376092
    'PEAK': '#FF7232',
    //#FF3300
    'HIGH': '#729135',
    //#729135
    'MEDIUM': '#D0ABDE',
    //#D0ABDE
    'LOW': '#79CAF2',
    //#79CAF2
    'UNUSED': '#ccc'
  };
  var seasonsIndexMap = {
    'SUPER PEAK': 1,
    'SUPERPEAK': 1,
    'PEAK': 2,
    'HIGH': 3,
    'MEDIUM': 4,
    'LOW': 5
  };
  var eventColors = ['#B0EA3B', '#F0A328', '#5FE9EA', '#FF00FF', '#904F92', '#3399CC', '#FFCC00', '#2A6769', '#FF6600', '#FFCCFF'];
  var eventIndex = 0;
  var eventsMap = {
    'THANKSGIVING': '#FFC694',
    'CHRISTMAS': '#CC7025',
    'SUPER BOWL': '#804f92',
    'EASTER': '#F0A328',
    'SPRING BREAK': '#ff3300',
    'USEREXCLUDED': '#ff3300'
  };
  var lighterColorMap = {};
  function getSortedSeasonMenu(chartDataLegend) {
    return _.chain(chartDataLegend).filter(function (n) {
      return !isSpecialEvent(n.label);
    }).map(function (item) {
      var seasonName = item.label;
      var upperCaseName = seasonName && seasonName.toUpperCase();
      return {
        season: seasonName,
        index: seasonsIndexMap[upperCaseName],
        active: false
      };
    }).sortBy('index').value();
  }
  function isSpecialEvent(eventName) {
    return eventsMap[eventName.toUpperCase()] ? true : false;
  }
  function getColor(name, lightenAmount) {
    var uppercaseName = name && name.toUpperCase();
    var colorForSeason = seasonsMap[uppercaseName];
    var colorForEvent = eventsMap[uppercaseName];
    var lightenedColor;
    if (colorForSeason) {
      return colorForSeason;
    }
    if (colorForEvent) {
      if (lightenAmount) {
        lightenedColor = lightenColor(colorForEvent, lightenAmount);
        _.set(lighterColorMap, colorForEvent, lightenedColor);
        return {
          dark: colorForEvent,
          light: lightenedColor
        };
      }
      return colorForEvent;
    }
    var newColorForEvent = eventColors[eventIndex++ % eventColors.length];
    eventsMap[uppercaseName] = newColorForEvent;
    if (lightenAmount) {
      lightenedColor = lightenColor(newColorForEvent, lightenAmount);
      _.set(lighterColorMap, newColorForEvent, lightenedColor);
      return {
        dark: newColorForEvent,
        light: lightenedColor
      };
    }
    return newColorForEvent;
  }
  function isSeason(name) {
    return !_.isNil(seasonsMap[name]);
  }
  function lightenColor(color, amount) {
    if (_.has(lighterColorMap, color)) {
      return _.get(lighterColorMap, color);
    }
    color = color.slice(1);
    var num = parseInt(color, 16);
    var r = (num >> 16) + amount;
    if (r > 255) {
      r = 255;
    } else if (r < 0) {
      r = 0;
    }
    var b = (num >> 8 & 0x00FF) + amount;
    if (b > 255) {
      b = 255;
    } else if (b < 0) {
      b = 0;
    }
    var g = (num & 0x0000FF) + amount;
    if (g > 255) {
      g = 255;
    } else if (g < 0) {
      g = 0;
    }
    return ('#' + (g | b << 8 | r << 16).toString(16)).toUpperCase();
  }
  return {
    getColor: getColor,
    isSpecialEvent: isSpecialEvent,
    getSortedSeasonMenu: getSortedSeasonMenu,
    isSeason: isSeason
  };
};
SeasonColorService.$inject = [];
module.exports = SeasonColorService;